// extracted by mini-css-extract-plugin
module.exports = {"trustpilotWrapper":"TrustpilotWidget_trustpilotWrapper__YETnf","ratingWrapper":"TrustpilotWidget_ratingWrapper__R560q"};